// Vue
import { Component, Prop, Vue } from "vue-property-decorator";
// Template
import template from "./template.vue";
import { getTranslatedImage as getTranslatedImageHelper } from "#/common/ModuleHelpers";
import { ImageAspectRatio } from "#/components/image_aspect_ratio/ImageAspectRatio";

@Component({
  mixins: [template],
  components: {
    ImageAspectRatio,
  },
})
export class PiOverviewModuleItem extends Vue {
  @Prop()
  public item!: object;

  @Prop()
  public lang!: string;

  public getTranslatedImage(imageObject, language, size) {
    return getTranslatedImageHelper(imageObject, language, size);
  }

  public openPiLayer() {
    if (this.item["link"] && this.item["link"]["href"]) {
      if (this.item["link_target"] === "_blank") {
        window.open(this.item["link"]["href"], "_blank");
      } else {
        window.location.href = this.item["link"]["href"];
      }
    } else {
      this.$eventBus.$emit("cms.pi_module.open", this.item["layer_id"]);
    }
  }

  get isLink() {
    return this.item["layer_id"] || this.item["link"];
  }
}
